import { VALID_SORTING_METHODS } from '@common/types';

export function isValidSortingMethod(sortMethod?: string | null): boolean {
  const found = VALID_SORTING_METHODS.find(
    (validName) => validName === sortMethod,
  );
  return !!found;
}
